import * as yup from "yup";

export const editProfileSchema = yup.object().shape({
  businessName: yup.string().optional(),
  contactName: yup.string().optional(),
  email: yup.string().email("Invalid email").optional(),
  taxId: yup.string().optional(),
  licenseNumber: yup.string().optional(),
  phone: yup.string().optional(),
  description: yup.string().optional(),
  businessAddress: yup.string().optional(),
});
